import {Action, handleActions} from 'redux-actions';
import {TimespanCategoryType} from '@pluto/rest';
import {
    TIMESPAN_CATEGORIES_RESET,
    TIMESPAN_CATEGORY_RESET,
    TIMESPAN_CATEGORY_SET,
} from './TimespanCategoriesActions';
import {
    CategoriesPayload,
    TimespanCategoriesState,
} from './TimespanCategoriesTypes';

export const setCategory = (state: TimespanCategoriesState, {payload}: Action<CategoriesPayload>): TimespanCategoriesState => {
    const {
        type,
        categories,
    } = payload;
    
    if (categories)
        return {
            ...state,
            [type]: Array.from(categories),
        };
    
    return state;
};

export const resetCategory = (state: TimespanCategoriesState, {payload}: Action<TimespanCategoryType>): TimespanCategoriesState => {
    const type = payload;
    return {
        ...state,
        [type]: [],
    };
};

export const resetCategories = (): TimespanCategoriesState => {
    return initialState;
};

export const initialState: TimespanCategoriesState = {
    media: [],
    metadata: [],
    artwork: [],
    rights: [],
    markup: [],
};

const handlers = {
    [TIMESPAN_CATEGORY_SET]: setCategory,
    [TIMESPAN_CATEGORY_RESET]: resetCategory,
    [TIMESPAN_CATEGORIES_RESET]: resetCategories,
};

export default handleActions<TimespanCategoriesState, any>(handlers, initialState);
